// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DialogActionModal__buttonsContainer____OZ8p","propmptBox":"DialogActionModal__propmptBox___V__qe"};